<template>
    <div>
        <table class="table w-full">
            <thead>
                <tr>
                    <sortable-header
                        @sort="handleSort"
                        sort-by="item_number"
                        :direction="sort_direction"
                        :column="sort_column"
                        class="text-left border-b-2 border-gray py-2 px-2 whitespace-nowrap"
                    >
                        Item #
                    </sortable-header>

                    <sortable-header
                        @sort="handleSort"
                        sort-by="title"
                        :direction="sort_direction"
                        :column="sort_column"
                        class="text-left border-b-2 border-gray py-2 px-2"
                    >
                        Title
                    </sortable-header>

                    <sortable-header
                        @sort="handleSort"
                        sort-by="description"
                        :direction="sort_direction"
                        :column="sort_column"
                        class="text-left border-b-2 border-gray py-2 px-2"
                    >
                        Description
                    </sortable-header>

                    <sortable-header
                        @sort="handleSort"
                        sort-by="uom"
                        :direction="sort_direction"
                        :column="sort_column"
                        class="text-left border-b-2 border-gray py-2 px-2 whitespace-nowrap"
                    >
                        Unit of Measure
                    </sortable-header>

                    <sortable-header
                        @sort="handleSort"
                        sort-by="stock"
                        :direction="sort_direction"
                        :column="sort_column"
                        class="text-right border-b-2 border-gray py-2 px-2 whitespace-nowrap"
                    >
                        Qty on Hand
                    </sortable-header>

                    <sortable-header
                        @sort="handleSort"
                        sort-by="required"
                        :direction="sort_direction"
                        :column="sort_column"
                        class="text-right border-b-2 border-gray py-2 px-2 whitespace-nowrap"
                    >
                        Qty Needed
                    </sortable-header>

                    <sortable-header
                        @sort="handleSort"
                        sort-by="qty_short"
                        :direction="sort_direction"
                        :column="sort_column"
                        class="text-right border-b-2 border-gray py-2 px-2 whitespace-nowrap"
                    >
                        Qty Short
                    </sortable-header>

                    <sortable-header
                        @sort="handleSort"
                        sort-by="short_date"
                        :direction="sort_direction"
                        :column="sort_column"
                        class="text-left border-b-2 border-gray py-2 px-2 whitespace-nowrap"
                    >
                        Short Date
                    </sortable-header>
                </tr>
            </thead>

            <tbody>
                <tr v-for="item in data" :key="item.item_number">
                    <td class="px-2 py-1">
                        <Link :href="route('products.edit', item.item_number)" preserve-scroll class="underline" @click.stop>
                            {{ item.item_number }}
                        </Link>
                    </td>
                    <td class="px-2 py-1">{{ item.title }}</td>
                    <td class="px-2 py-1">{{ item.description }}</td>
                    <td class="px-2 py-1">{{ item.uom }}</td>
                    <td class="px-2 py-1 whitespace-nowrap text-right">{{ formatNumber(item.stock) }}</td>
                    <td class="px-2 py-1 whitespace-nowrap text-right">
                        <BetterTooltip>
                            <template #reference>
                                {{ formatNumber(item.required) }}*
                            </template>
                            <template #floating>
                                <div class="text-sm max-h-80 overflow-y-auto">
                                    <div v-for="order in item.orders" :key="order.order_id" class="mb-1">
                                        <Pill color="light" :size="'sm'" :variant="'soft'" class="w-full">
                                            <Link :href="route('orders.show', order.order_id)" class="underline" @click.stop>
                                                {{ order.order_number }}
                                            </Link> - {{ formatNumber(order.quantity) }} ({{ formatDate(order.ship_date) }})
                                        </Pill>
                                    </div>
                                </div>
                            </template>
                        </BetterTooltip>
                    </td>
                    <td class="px-2 py-1 whitespace-nowrap text-right">{{ formatNumber(item.qty_short) }}</td>
                    <td class="px-2 py-1 whitespace-nowrap">{{ item.short_date }}</td>
                </tr>
            </tbody>

        </table>
    </div>
</template>

<script>
import SortableHeader from '@/Shared/SortableHeader';
import { Link } from '@inertiajs/inertia-vue3';
import BetterTooltip from '@/Jetstream/BetterTooltip';
import Pill from '@/Jetstream/Pill';
import { DateTime } from "luxon";

export default {
    components: {
        SortableHeader,
        Link,
        BetterTooltip,
        Pill,
    },

    props: ['data', 'sort_column', 'sort_direction'],
    emits: ['sort'],

    methods: {
        handleSort(sort) {
            this.$emit('sort', sort);
        },
        formatNumber(value) {
            if (value === null || value === undefined) {
                return '';
            }
            const num = parseFloat(value);
            if (isNaN(num)) {
                return value;
            }
            // Format with up to 2 decimal places, removing trailing zeros
            return num % 1 === 0 ? num.toString() : num.toFixed(2).replace(/\.?0+$/, '');
        },
        formatDate(date) {
            if (!date) {
                return '';
            }
            return DateTime.fromISO(date).toFormat('MMM d, yyyy');
        }
    }
}
</script>
